import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useEffect } from 'react'

import { get } from '../../../helpers/request'
import t from '../../../helpers/i18n'
import { withRouter } from 'react-router-dom'

const DivisionView = ({ history, match }) => {
  const [[divisionState, division], setDivision] = useVisualState()
  const division_id = match.params.divisionId

  useEffect(() => {
    setDivision(LOADING)
    get('/soccer/competitions/divisions/' + division_id)
      .then((response) => {
        setDivision(READY, response)
      })
      .catch((error) => {
        setDivision(ERROR, error)
      })
  }, [setDivision, division_id])

  return (
    <div>
      {divisionState === LOADING && <div>{t('titles.Loading')}</div>}
      {divisionState === READY && (
        <div>
          <h2>{t('titles.Division')}: {division.name}</h2>
          <button
            onClick={() =>
              history.push(
                '/soccer/competitions/divisions/' + division_id + '/teams/add'
              )
            }
          >
            {t('buttons.Add_team')}
          </button>
          <h3>{t('titles.Teams')}</h3>
          <ul>
            {division.teams.map((team) => (
              <li key={team.team_id}>{team.name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default withRouter(DivisionView)
